import {
  ORDER_AGGREGATORS_QUOTATION_REQUEST,
  ORDER_AGGREGATORS_QUOTATION_REQUEST_SUCCESS,
  ORDER_AGGREGATORS_QUOTATION_REQUEST_FAIL
} from 'constants/action-types';

const initialState = {
  data: null
};

export default (state = initialState, action) => {
  switch (action.type) {
    case ORDER_AGGREGATORS_QUOTATION_REQUEST:
      return initialState;

    case ORDER_AGGREGATORS_QUOTATION_REQUEST_SUCCESS:
      return {
        url: action.payload.data
      };

    case ORDER_AGGREGATORS_QUOTATION_REQUEST_FAIL:
      return {
        ...state,
        error: action.error.response
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/orderAggregators/quotation.js